import { connect } from 'react-redux'
import CompanyProfileComponent from '../../../components/employer/companyProfile/companyProfile.component'
import {
  getFieldOfWork,
  getOperatorsEinvoice,
  loadProfileStart,
  updateProfile,
  closeProfileSnackbar,
  getTotalApplications
} from '../../../actions/employer'
import { createMenuItems } from '../../../utils/invoice.utils'
import { getCountryList } from '../../../actions'

const mapStateToProps = (state) => {
  const fieldOfWork = state.companyProfile.fieldOfWork
    ? state.companyProfile.fieldOfWork
    : []
  const invoiceOperators = state.companyProfile.eInvoiceOperators
    ? state.companyProfile.eInvoiceOperators
    : []
  let emptyOperator = ['']
  let combineOperators = []
  combineOperators = emptyOperator.concat(invoiceOperators)
  const eInvoiceOperators = createMenuItems(combineOperators)
  return {
    state,
    fieldOfWork: fieldOfWork,
    eInvoiceOperators: eInvoiceOperators,
    showSnackbar: state.companyProfile.showSnackbar,
    showFailedSnackbar: state.companyProfile.showFailedSnackbar,
    countryList: state.companyProfile.countryList
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getFieldOfWork: () => dispatch(getFieldOfWork()),
    getOperatorsEinvoice: () => dispatch(getOperatorsEinvoice()),
    loadProfileStart: () => dispatch(loadProfileStart()),
    updateProfile: (formValues) => dispatch(updateProfile(formValues)),
    closeProfileSnackbar: () => dispatch(closeProfileSnackbar()),
    getTotalApplications: () => dispatch(getTotalApplications()),
    getCountryList: () => dispatch(getCountryList())
  }
}

const CompanyProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyProfileComponent)

export default CompanyProfileContainer
